import styled from 'styled-components';

import { SelectColor } from '../../../../../services/reports';

export const RenderStyleSVG = styled.div`
	svg.google {
		.st0{fill:#FBBD04;}
		.st1{fill:#438EDC;}
		.st2{fill:#34A952;}
		.st3{fill:#7F7F7F;}
	}
	
	svg.clicks {
		.st0 {
			fill:none;
		}
		.st1 {
			display:none;
		}
		.st2 {
			display:inline;
			fill: #B7B7B7;
		}
		.st3{
			display:inline;
		}
		.st4{
			fill: ${props => SelectColor(props.channel)};
		}
		.st6{
			fill:#FFFFFF;
		}
		.st7{
			fill:#B7B7B7;
		}
		.st8{
			fill:#888787;
		}
		.st9{
			fill:#11FF00;
		}
		.st10{
			fill:#B1B1B1;
		}
		.st11{
			fill: ${props => SelectColor(props.channel)};
		}
		.st12{
			fill: ${props => SelectColor(props.channel)};
		}
	}
	
	svg.impressions {
		.st0 {
			fill: ${props => SelectColor(props.channel)};
		}
	}
	
	svg.ranking {
		.st0{
			fill: ${props => SelectColor(props.channel)};
		}
	}
	
	svg.ctr {
		.st0{fill:none;}
		.st1{display:none;}
		.st2{display:inline;fill: ${props => SelectColor(props.channel)};}
		.st3{display:inline;}
		.st4{fill: ${props => SelectColor(props.channel)};}
		.st6{fill:#FFFFFF;}
		.st7{fill:#B7B7B7;}
		.st8{fill:#888787;}
		.st9{fill:#11FF00;}
		.st10{fill:#B1B1B1;}
		.st11{fill: ${props => SelectColor(props.channel)};}
		.st12{fill: ${props => SelectColor(props.channel)};}
	}
`;

export const StyledCardsDevices = styled.div`
  display: flex;
  align-items: center;
  font-family: Poppins, Heltica, Arial, sans-serif;
  color: #707070;
  
  .container-devices {
    display: flex;
		margin: 30px 0;
    
    .element-1,
    .element-2 {
      display: flex;
      align-items: center;
    }
    
    .element-1 {
      margin-right: 30px;
      
      .content-devices {
        margin-left: 20px;
      }
    }
  }
  
  h5 {
    font-size: 27px;
    margin: 0;
  }
  
  p {
    font-size: 14px;
    margin: 0;
  }
  
  .content-devices {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;
    
    &:last-child {
      margin-left: 8px;
    }
  }
`;

export const RenderColorSVGDesktop = styled.div`
  svg {
    .st0{display:none;}
    .st1{display:inline;}
    .st2{fill:${props => props.color};}
    .st3{display:inline;fill:${props => props.color};}
    .st4{fill:none;stroke:${props => props.color};stroke-width:1.5;stroke-miterlimit:10;}
  }
`;


export const RenderColorSVGMobile = styled.div`
  svg {
    path {
      fill: ${props => props.color};
    }
  }
`;
